import {takeLatestF, Response, putAll, showBeError} from '@fl/cmsch-fe-library';
import {SagaIterator} from 'redux-saga';
import {none, opt} from 'ts-opt';
import {call, put, select} from 'typed-redux-saga';

import {Api} from 'api/gen/Api';
import {PagedModelStableToChoose} from 'api/gen/PagedModelStableToChoose';
import {ProductionAreaInCE} from 'api/gen/ProductionAreaInCE';
import {t} from 'app/translations';
import {tablesAction, simpleTableSelector, getTableFiltersAndParams} from 'utils/tables';

import {potentiallyChangeOfTableDataSource} from '../../utils/potentially-change-of-table-data-source';
import {animalBrowserAction, GetStablesDataAction} from '../action';

const tableId = 'stableToChoose';

function* execute(action: GetStablesDataAction): SagaIterator {
    const {tableDataRequest} = action.payload;

    if (tableDataRequest.isEmpty) return yield* put(animalBrowserAction.getStablesTableDataSuccess(none));
    yield* put(tablesAction.tableDataFetchStart(tableId));

    const tableState = yield* select(simpleTableSelector.tableState(tableId));
    const {filters, params, tableDataParams} = getTableFiltersAndParams({tableId, tableDataRequest, tableState});

    const response: Response<PagedModelStableToChoose> = yield* call(Api.getStablesToChoose, filters, params);

    if (response.isSuccess) {
        yield* put(animalBrowserAction.getStablesTableDataSuccess(opt(response.data)));
        yield* put(tablesAction.tableDataFetchSuccess(tableId, tableDataParams));
    } else {
        yield putAll(showBeError(response, t('animalBrowser')('farmsStables')));
    }
    if (potentiallyChangeOfTableDataSource(tableDataRequest.orCrash('No tableDataRequest'))){
        const prodAreasReponse = yield* call(Api.getProductionAreasInCentralEvidence);
        if (prodAreasReponse.isSuccess) {
            const options = prodAreasReponse.data.map((prod: ProductionAreaInCE) => ({
                value: prod.name,
                label: prod.name,
            }));

            yield* put(animalBrowserAction.getProductionAreasInCentralEvidenceSuccess(options));
        }
    }
}

/**
 * Loads the stable overview table.
 *
 * @returns The saga watcher for `GET_STABLES_DATA`.
 */
export function* getStablesDataSaga(): SagaIterator {
    yield takeLatestF('animalBrowser/GET_STABLES_DATA', execute);
}
